const overrideListItems = (theme) => {
  theme.overrides.MuiListItem = {
    root: {
      '&$selected': {
        backgroundColor: theme.colorPalette.white,
        fontWeight: 600,
        '&:hover': {
          backgroundColor: theme.colorPalette.green_75_op_10
        }
      }
    },
    button: {
      '&:hover': {
        color: theme.palette.common.green_100,
        backgroundColor: theme.colorPalette.green_75_op_10
      }
    }
  };
};

export default overrideListItems;
